import { AnimatedSizeContainer } from "@/components";
import { Box } from "@mui/material";
import { grey, purple } from "@mui/material/colors";
import { FC } from "react";
import { useInView } from "react-intersection-observer";
import { ChatMessageProps } from "./chat-message.types";
import { InnerMessage } from "./inner-message.component";

const ChatMessage: FC<ChatMessageProps> = ({
  type,
  position,
  createdAt,
  read,
  feedback,
  attachment,
  message,
  onVisible,
}) => {
  const { ref } = useInView({
    threshold: 1,
    triggerOnce: true,
    skip: !onVisible,
    onChange: (inView) => {
      if (inView && onVisible) {
        onVisible();
      }
    },
  });

  return (
    <Box ref={ref}>
      <AnimatedSizeContainer height>
        <Box
          sx={{
            alignItems: "flex-end",
            maxWidth: "70%",
            padding: 1,
            borderRadius: 4,
            justifySelf: `flex-${position}`,
            backgroundColor: position === "start" ? grey["800"] : purple["800"],
            margin: `0 ${position === "end" ? "8px" : 0} 0 ${
              position === "start" ? "8px" : 0
            }`,
          }}
        >
          {!attachment && type === "feedback" && (
            <InnerMessage.Feedback
              read={read}
              message={message}
              feedback={feedback}
              createdAt={createdAt}
            />
          )}

          {!attachment && type === "text" && (
            <InnerMessage.Text
              read={read}
              message={message}
              createdAt={createdAt}
            />
          )}

          {attachment && (
            <InnerMessage.Attachment
              read={read}
              message={message}
              createdAt={createdAt}
              attachment={attachment}
            />
          )}
        </Box>
      </AnimatedSizeContainer>
    </Box>
  );
};

export { ChatMessage };
